import axios from "@/plugins/axios";
import { Trans } from "@/plugins/i18n/translationHandler";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    ...mapActions("regions", ["setRegions"]),
    ...mapActions("dates", ["setYears", "setMonthRange"]),
    ...mapActions("periods", ["setPeriods"]),
    ...mapActions("markets", ["setMarkets"]),
    async fetchLists() {
      Promise.all([
        this.fetchRegions(),
        this.fetchYears(),
        this.fetchMarketsComplete(),
      ])
        .then((res) => {
          // Handle Region response
          this.setRegions([
            {
              wholeRegion: this.$t("utils.globalSpot"),
              regions: res[0].data,
            },
          ]);
          // Handle markets response
          this.setMarkets(
            [{ Text: this.$t("utils.totalMarkets"), Value: "0" }].concat(
              res[2].data
            )
          );

          // Handle Year response
          this.setYears(
            this.computeYears(
              moment(res[1].data.min).year(),
              moment(res[1].data.max).year()
            )
          );
          this.setMonthRange(
            this.computeRange(res[1].data.min, res[1].data.max)
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchRegions() {
      return axios.post(`lists/regions`, {
        language: Trans.currentLocale,
        ...this.$utils.getDestinationParams(),
      });
    },
    fetchYears(source) {
      if (source == "airdna") 
        return axios.get(`airdna/latestPeriod`);
      else 
        return axios.get(`hesta/GetPeriodRange`);
    },
    fetchPeriods() {
      return axios.get(`lists/periods`);
    },
    computeYears(min, max) {
      const years = [];
      for (let i = min; i <= max; i++) years.push(i);
      return years;
    },
    computeRange(min, max) {
      return {
        minDate: moment(min).format("MM-DD-YYYY"),
        maxDate: moment(max).format("MM-DD-YYYY"),
      };
    },
    fetchMarkets() {
      return axios.post(`hesta/GetCountriesForPeriod`, {
        language: Trans.currentLocale,
      });
    },
    fetchMarketsComplete() {
      return axios.post(`hesta/GetGrouppedCountries`, {
        language: Trans.currentLocale,
      });
    },
    stopLoading() {
      this.loading = false;
    },
  },
};
